import api from '@/services/api/api';
import { skipToken, useQuery } from '@tanstack/react-query';

type TGetService = {
  serviceId?: string;
  organizationCode: string;
};

const isUUID = (id: string) => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
};

const useGetServiceByIdOrCode = ({
  serviceId,
  organizationCode
}: TGetService) => {
  return useQuery({
    queryKey: ['services', organizationCode, serviceId],
    queryFn: serviceId
      ? isUUID(serviceId)
        ? () => api.services.getServiceById(serviceId)
        : () => api.services.getServiceByCode(serviceId, organizationCode)
      : skipToken,
    enabled: !!serviceId && (!!organizationCode || isUUID(serviceId))
  });
};

export default useGetServiceByIdOrCode;
